import React, { useState, useRef, useEffect } from 'react';
import './ResidentForm.css';

function ResidentForm({ addResident, schedulerMode }) {
  const [name, setName] = useState('');
  const [daysOff, setDaysOff] = useState('');
  const [max1inX, setMax1inX] = useState('');
  const nameInputRef = useRef(null);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const daysOffArray = daysOff.split(',').map(date => date.trim());
    addResident({ 
      name, 
      daysOff: daysOffArray, 
      max1inX: max1inX ? parseFloat(max1inX) : null
    });
    setName('');
    setDaysOff('');
    setMax1inX('');
    nameInputRef.current.focus();
  };

  useEffect(() => {
    nameInputRef.current.focus();
  }, []);

  return (
    <form className="resident-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="name">Name:</label>
        <input 
          type="text" 
          id="name"
          placeholder="John Doe" 
          value={name} 
          onChange={(e) => setName(e.target.value)} 
          required 
          ref={nameInputRef}
        />
      </div>
      <div className="form-group">
        <label htmlFor="daysOff">Dates Off (optional):<p className="days-off-info">Write preferred dates in descending order.</p></label>
        <input 
          type="text"
          id="daysOff"
          placeholder="yyyy-mm-dd, yyyy-mm-dd" 
          value={daysOff} 
          onChange={(e) => setDaysOff(e.target.value)} 
          pattern="^(\d{4}-\d{2}-\d{2})(,\s*\d{4}-\d{2}-\d{2})*$"
          title="Please enter dates in the format yyyy-mm-dd, yyyy-mm-dd"
        />
      </div>
        <div className="form-group">
          <label htmlFor="max1inX">1 in X Call (optional):</label>
          <input 
            type="number" 
            id="max1inX"
            placeholder="4"
            value={max1inX} 
            onChange={(e) => setMax1inX(e.target.value)} 
            min="1"
            step="1"
          />
        </div>
      <button type="submit">Add Name</button>
    </form>
  );
}

export default ResidentForm;